import MaterialIcon from '@components/common/MaterialIcon';
import { LANGUAGE_COUNTRY_CODES } from '@conversed/shared/src/central/constants/languages';
import type React from 'react';

type FlagEmojiProps = {
  languageCode: string;
  size?: number;
  className?: string;
};

export const FlagEmoji: React.FC<FlagEmojiProps> = ({
  languageCode,
  size = 16,
  className = '',
}) => {
  const countryCode = LANGUAGE_COUNTRY_CODES[languageCode];

  if (!countryCode) {
    return (
      <span
        style={{ fontSize: size }}
        className={`inline-block align-middle ${className}`}>
        <MaterialIcon icon='language' classes={['text-gray-400']} />
      </span>
    );
  }
  return (
    <img
      src={`https://flagcdn.com/w40/${countryCode}.png`}
      alt={languageCode}
      style={{
        height: size,
        width: Math.round(size * 1.5),
        objectFit: 'cover',
      }}
      className={`inline-block align-middle ${className}`}
      draggable={false}
    />
  );
};
